// 发票类型
export const InvoiceType = {
  TRANSPORT: '运输',
  WAREHOUSING: '仓储'
}

// 发票类别
export const InvoiceCategory = {
  NORMAL: '普票',
  SPECIAL: '专票'
}

// 合同状态
export const ContractStatusText = {
  DRAFT: '草稿',
  ENABLED: '已生效',
  EXPIRED: '已失效',
  DISABLED: '已禁用'
}

export const SMSTYPE = {
  forgetPwd: 'CUSTOMER_RETRIEVE_PWD',
  login: 'CUSTOMER_ACCOUNT_LOGIN',
  register: 'CUSTOMER_ACCOUNT_REGISTER'
}

export const TERMSURL = {
  service: 'https://staticpage.yunlizhi.cn/userAgreement/userAgreement.html',
  privacy: 'https://staticpage.yunlizhi.cn/consignorMiniprogram/privacyPolicy.html'
}